import { inject, Injectable } from '@angular/core';
import { Transaction } from '@softapps/wws/pos-core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_UNSETTLED_TRANSACTIONS } from '@softapps/wws/pos-core';

@Injectable()
export class TransactionRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async loadAll(accountId: number): Promise<Transaction[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_UNSETTLED_TRANSACTIONS,
      pathParams: { accountId },
    });
  }
}
